import { FC } from "react";
import style from "./style.module.scss";
import { TreeProps } from "./type";
import { Folder } from "./folder";

export const FolderTree: FC<TreeProps> = ({ structure, ...selectedProps }) => (
  <div className={style.tree}>
    <Folder
      node={{
        name: "Home",
        fullPath: `${structure.name}/`,
        children: structure.children,
      }}
      {...selectedProps}
    />
  </div>
);
